<template>
    <client-page className="header--light">
        
        <sub-visual
        sh="인재채용"
        tabActive="채용 FAQ"
        bg="/images/sub/visual/sv4-6.jpg">
        </sub-visual>

        <section class="section">
            <v-container>
                
                <div class="tit-wrap text-center">
                    <h3 class="tit">
                        채용 FAQ
                    </h3>
                    <p class="tit-txt">
                        여러분의 궁금증을 풀어드립니다.
                    </p>
                </div>

                <faq-list :type="filter.type"></faq-list>

            </v-container>
        </section>

	</client-page>
</template>

<script>

import ClientPage from "@/pages/client/templates/ClientPage.vue";
import SubVisual from "@/components/client/sub/sub-visual.vue";
import FaqList from "@/components/client/center/faqs/faq-list.vue";

export default{
	components: {
        ClientPage,
        SubVisual,
		FaqList,
    },
    mounted() {
        console.log(this.filter.type);
    },
    data() {
        return {
            filter: {
                type: "세일즈웍스 코리아"
            }
        }
    },
    watch: {
        "filter.type"() {
        }
    }
}
</script>
